export var IMAGE_URL = 'imageUrl';
export var SRC_SET = 'srcSet';